import React, { useContext, useEffect } from 'react'
import useMemberTable from '../context/MemberTableContext'
import MicroModal from 'micromodal'
import { ColumnDef, ColumnFiltersState, SortingState } from '@tanstack/react-table'
import { useParams } from 'react-router-dom'
import TableCheckbox from '../../../../common/checkbox/TableCheckbox'
import { getExportHeaders } from '../../ReportingGroup/types/tableHeaders'
import TanstackContent from '../../Table/Tanstack/TanstackContent'
import { TeamContext } from '../../MenuTabs/MenuTabs'
import { InviteLinkTableData, InviteLinkTableType } from '../data/InviteLinksData'
import CreateLinksModal from './CreateLinksModal'
import Button from '../../../../common/button/Button'

const InviteLinksTable = ({ inviteLinksData }) => {

  const [ columnFilters, setColumnFilters ] = React.useState<ColumnFiltersState>([])
  const { setUseHeader } = useMemberTable()
  const [ rowSelection, setRowSelection ] = React.useState({})
  const [ globalFilter, setGlobalFilter ] = React.useState('')
  const [ sorting, setSorting ] = React.useState<SortingState>([])
  const [ data, setData ] = React.useState( () => InviteLinkTableData( inviteLinksData ) )
  const { refetchInviteLinks } = useMemberTable()

  const params = useParams()
  const teamId = params.team_id ?? 0
  const inviteBaseURL = inviteLinksData.home_url + inviteLinksData.base_links

  useEffect(() => {
    MicroModal.init()
    setUseHeader([ 'all' ])
  }, [])

  const columns = React.useMemo<ColumnDef<InviteLinkTableType>[]>(
    () => [
      {     
        id: 'select',
        header: ({ table }) => (
          <TableCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        ),
        cell: ({ row }) => (
          <div className="px-1">
            <TableCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        ),
      },
      {
        id: 'columns',
        columns: [
        //   {
        //     id: 'invitationId',
        //     accessorKey: 'invitationId',
        //     prettyName: 'Invitation ID',
        //     show: false,
        //     cell: info => info.getValue(),
        //     footer: props => props.column.id,
        //     header: () => <span>INVITATION ID</span>,
        //   },
          {
            id: 'link',
            accessorKey: 'link',
            prettyName: 'Link',
            show: true,
            cell: info => {
                const link = info.getValue()
                return inviteBaseURL + link
            },
            footer: props => props.column.id,
            header: () => <span>LINK</span>,
          },
          {
            id: 'preset',
            accessorKey: 'preset',
            prettyName: 'Preset',
            cell: info => {
                const preset = info.getValue()
                return preset?.label
            },
            footer: props => props.column.id,
            header: () => <span>PRESET</span>,
          },
          {
            id: 'actions',
            accessorKey: 'actions',
            enableSorting: false,
            prettyName: 'Actions',
            cell: (info) => (
              <Actions info={ info.row.original } />
            ),
            footer: props => props.column.id,
            header: () => <span>ACTIONS</span>,
            meta: {
              className: "msync-custom-member-action-header",
            },
          },
        ]
      }
    ],
    []
  )

  const exportHeaders = getExportHeaders('team-members')
  const { teamData } = useContext(TeamContext)

  const Actions = ({ info }) => {
    return (
      <div className='msync-table-action-column'>
        
      </div>
    )
  }

  const EditLinkBehavior = async (linkBehavior) => {
    const currentRestUrl = window.group_dashboard.base
    const nonce = window.group_dashboard.nonce

    const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/edit/link/behavior'
  
    await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          'link_behavior': JSON.stringify(linkBehavior)
        }),
        headers:{
          'X-WP-Nonce': nonce,
          'Content-type': 'application/json'
        }
    }).then(resp => {
        return resp.json()
    })
    .then((json) => {
    })
  }

  const link_behavior = inviteLinksData.link_behavior === '' ? 'auto' : inviteLinksData.link_behavior

  return (
    <>
      <CreateLinksModal 
        orgID={teamId}
        baseURL={inviteLinksData.base_links}
        refetch={() => refetchInviteLinks()}
      />
      <Button
        onClick={ () => MicroModal.show('msync-org-create-invites-links') }
      >
        Create
      </Button>
      {
        tangibleFields.render({
          type: 'radio',
          name: 'link-behavior',
          label: 'Link Behavior',
          choices: {
            'auto': 'Auto join',
            'create': 'Create join request'
          },
          value: link_behavior,
          onChange: (value) => {
            EditLinkBehavior( value )
          }
        })
      }
      <TanstackContent
        data={ data }
        columns={ columns }
        rowSelection={ rowSelection }
        setRowSelection={ setRowSelection }
        sorting={ sorting }
        setSorting={ setSorting }
        globalFilter={ globalFilter }
        setGlobalFilter={ setGlobalFilter }
        exportHeaders={ exportHeaders }
        from='Invite Links Table'
        context='Invite Links'
        hideFilters={ true }
        columnFilters={ columnFilters }
        setColumnFilters={ setColumnFilters }
      >
        <></>
      </TanstackContent>
    </>
  )
}

export default InviteLinksTable
